import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=49fc2560&scoped=true"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"
import style0 from "./Pages.vue?vue&type=style&index=0&id=49fc2560&prod&lang=scss&scoped=true"
import style1 from "./Pages.vue?vue&type=style&index=1&id=49fc2560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc2560",
  null
  
)

export default component.exports